import React from "react";

import "./Privacy.scss";

export const Privacy: React.FC = () => (
  <div className="infoModalContent infoModalContent--privacy">
    <h2>Privacy</h2>
    <p>Pentagram Design Limited Privacy Policy</p>
    <p>Introduction</p>
    <p>
      Welcome to the Pentagram privacy policy which governs your use of the
      &ldquo;808303studio&rdquo; experience which can be accessed at
      https://808303.studio/ (the &ldquo;Experience&rdquo;).
    </p>
    <p>
      Pentagram Design Limited (company number 01599748) (collectively referred
      to as &ldquo;Pentagram&rdquo;, "we", " us" or "our" in this privacy
      policy) is the owner and publisher of the Experience. Pentagram respects
      your privacy and is committed to protecting your Personal Data. This
      privacy policy will inform you how we look after your Personal Data when
      you visit and interact with the Experience regardless of where you visit
      it from and tell you about your privacy rights and how the law in our
      jurisdiction protects you.
    </p>
    <p>The following defined terms shall have the following meanings:</p>
    <p>
      &ldquo;Anonymous Data&rdquo; means Personal Data that has been amended to
      the extent that it no longer contains any identifying information and
      thus, no longer constitutes Personal Data;
    </p>
    <p>&ldquo;Children&rdquo; any person under the age of 16;</p>
    <p>
      &ldquo;Controller&rdquo; means the natural or legal person who (either
      alone or jointly or in common with other persons) determines the purposes
      for which and the manner in which any Personal Data are, or are to be,
      processed as outlined in the Data Protection Legislation.
    </p>
    <p>
      Data Protection Legislation: all applicable data protection and privacy
      legislation in force from time to time in the UK including the General
      Data Protection Regulation ((EU) 2016/679); the Data Protection Act 2018;
      the Privacy and Electronic Communications Directive 2002/58/EC (as updated
      by Directive 2009/136/EC) and the Privacy and Electronic Communications
      Regulations 2003 (SI 2003/2426) as amended.
    </p>
    <p>
      &ldquo;Personal Data&rdquo; has the meaning given to it in the Data
      Protection Legislation.
    </p>
    <p>
      &ldquo;Processor&rdquo; means any natural or legal person who processes
      the data on behalf of the Controller.
    </p>
    <p>
      &ldquo;Video Content&rdquo; means the video generated through interaction
      with the Experience which allows you to create music through clicking on
      the page. Only sounds are recorded and background sounds are not recorded.
    </p>
    <p>
      &ldquo;Social Media&rdquo; means social media platforms and accounts of
      the User, including but not limited to Facebook, Twitter and Instagram.
    </p>
    <p>
      &ldquo;User&rdquo; means any individual interacting with the Experience,
      each to be referred to as a &ldquo;User&rdquo; and, together, referred to
      as the &ldquo;Users&rdquo;.
    </p>
    <p>1. Important information and who we are</p>
    <p>Purpose of this privacy policy</p>
    <p>
      This privacy policy aims to give you information on how Pentagram collects
      and processes your Personal Data through your interaction with the
      Experience, including any Personal Data you may provide when interacting
      with the Experience and/or when you distribute Video Content.
    </p>
    <p>
      The Experience is not intended for Children and we do not knowingly
      collect Personal Data relating to Children. Pentagram accepts no liability
      for the processing of any Personal Data relating to Children where
      Pentagram was not aware that the subjects were Children.
    </p>
    <p>
      It is important that you read this privacy policy together with any other
      privacy policy or fair processing notice we may provide on specific
      occasions when we are collecting or processing Personal Data so that you
      are fully aware of how and why we are using your Personal Data. This
      privacy policy supplements any other notices and is not intended to
      override them unless specifically stated.
    </p>
    <p>Controller</p>
    <p>
      Pentagram is a data Controller in respect of certain Personal Data
      provided by customers when interacting with the Experience. Pentagram is a
      data Processor in respect of any Personal Data processed by Pentagram on
      behalf of any User in the manner dictated by the User and by third parties
      including suppliers, provided through a variety of methods.
    </p>
    <p>Changes to the privacy policy and your duty to inform us of changes</p>
    <p>
      It is important that the Personal Data we hold about you is accurate and
      current. Please keep us informed if any aspect of your Personal Data
      changes during your relationship with us. Any previous data held on you
      will be deleted to the fullest extent possible.
    </p>
    <p>Third-party links</p>
    <p>
      The Experience may include links to third-party websites, plug-ins and
      applications. Clicking on any of these links or enabling those connections
      may allow third parties not associated with Pentagram to collect or share
      data about you. We do not control these third-party websites and are not
      responsible for their privacy statements.
    </p>
    <p>
      We encourage you to read the privacy policy of every website you visit,
      but, for the avoidance of doubt, Pentagram accepts no liability for any
      data that has been unlawfully processed by third parties as a result of
      you accessing these links.
    </p>
    <p>2. The data we collect about you</p>
    <p>
      We may collect, use, store and transfer different kinds of Personal Data
      about you, which include but are not limited to, the following categories:
    </p>
    <p>
      Identity Data: means Personal Data that includes your Social Media handle,
      Social Media name, and visually identifiable data that includes your
      facial features as a whole in Video Content.
    </p>
    <p>
      Contact Data: means Personal Data that includes your contact information,
      such as your email address.
    </p>
    <p>
      Technical Data may include internet protocol (IP) addresses you may have
      visited, the type and version of browser you are using, the time zone
      setting and location from which you are accessing the Experience, browser
      plug-in types and versions, which operating system and platform are being
      used and other technology on the devices you use to interact with the
      Experience.
    </p>
    <p>
      Usage Data includes information about how you interact with the Experience
      such as the full uniform resource locations (URL) clickstream to, through
      and from the Experience (including date and time), where the URL
      customised for Video Content has been sent to or shared on Social Media
      (not where it is shared to locations and servers other than Social Media),
      pages you viewed or searched for, page response times, download errors,
      length of visits of certain pages, page interaction information (such as
      scrolling, clicks, and mouse-overs), and methods used to browse away from
      the page.
    </p>
    <p>
      We do not collect nor ask for any Special Categories of Personal Data
      about you. Special categories mean the kinds of Personal Data recognised
      by the Data Protection Legislation as being more sensitive in nature than
      other categories of Personal Data. This includes details about your race
      or ethnicity, religious or philosophical beliefs, sex life, sexual
      orientation, political opinions, trade union membership, information about
      your health and genetic and biometric data. Nor do we collect any
      information about whether you have any prior criminal convictions and/or
      offences. Whilst we do not collect nor ask for Special Categories of
      Personal Data, we are aware that facial features as a whole in the videos
      may identify race or ethnicity, however this would never be used in a way
      to categorise or discriminate against Users or their Personal Data.
    </p>
    <p>3. How is your Personal Data collected?</p>
    <p>
      We use different methods to collect Personal Data from and about you
      including through:
    </p>
    <p>
      Direct interactions. You may give us your Identity and Contact Data by
      interacting with the Experience. This includes Personal Data you provide
      when you:
    </p>
    <p>record Video Content when interacting with the Experience; or</p>
    <p>
      share your recorded Video Content on Social Media when interacting with
      the Experience; or
    </p>
    <p>
      share the personalised URL of your recorded Video Content on Social Media;
      or
    </p>
    <p>
      share the personalised URL of your recorded Video Content with other
      individuals; or
    </p>
    <p>save and download the Video Content onto your server; or</p>
    <p>give us some feedback.</p>
    <p>
      Automated technologies or interactions. As you interact with the
      Experience, we may automatically collect Technical Data about your
      equipment, browsing actions, sharing actions and patterns. We collect this
      Personal Data by using cookies, server logs and other similar
      technologies. We may also receive Technical Data about you if you visit
      other websites employing our cookies.
    </p>
    <p>
      Third parties or publicly available sources. We may receive Personal Data
      about you from various third parties and public sources as set out below:
    </p>
    <p>Technical Data from the following parties:</p>
    <p>analytics providers;</p>
    <p>advertising networks; and</p>
    <p>search information providers.</p>
    <p>
      Identity and Contact Data from publicly availably sources such as Social
      Media accounts.
    </p>
    <p>4. How we use your Personal Data</p>
    <p>
      We will only use your Personal Data when and to the extent permitted by
      the Data Protection Legislation. Most commonly, we will use your Personal
      Data in the following circumstances:
    </p>
    <p>
      to provide access to your Video Content to any other User with whom you
      have sought to share your Video Content through sharing your personalised
      URL link for the Video Content;
    </p>
    <p>
      we post a link to your Video Content to Social Media accounts in
      accordance with your directions;
    </p>
    <p>
      where we need to store Video Content created by you on our server provided
      by Amazon Web Services (&ldquo;AWS&rdquo;). The Video Content will not be
      shared or disclosed to any other individual (other than in accordance with
      your directions when you seek to share Video Content). You cannot delete
      Video Content from our server held with AWS after sharing the URL.
      However, you may at any time make an Erasure Request (see details below);
    </p>
    <p>where we need to notify you about changes to the Experience;</p>
    <p>
      where it is necessary for our legitimate interests (or those of a third
      party) and your interests and your fundamental rights do not override
      those interests; or
    </p>
    <p>where we need to comply with a legal or regulatory obligation.</p>
    <p>
      Generally, we do not rely on consent as a legal basis for processing your
      Personal Data.
    </p>
    <p>Purposes for which we will use your Personal Data</p>
    <p>
      We have set out below, in a table format, a description of all the ways we
      plan to use your Personal Data, and which of the legal bases we rely on to
      do so. We have also identified what our legitimate interests are where
      appropriate.
    </p>
    <p>
      Note that we may process your Personal Data for more than one lawful
      ground depending on the specific purpose for which we are using your data.
      Please contact us if you need details about the specific legal ground we
      are relying on to process your Personal Data where more than one ground
      has been set out in the table below.
    </p>
    <p>
      For the avoidance of doubt, this table is not exhaustive of the ways in
      which Pentagram may use your Personal Data and there may be occasions
      where we require additional information.
    </p>
    <p>Purpose / Activity</p>
    <p>Type of data</p>
    <p>Lawful basis for processing including basis of legitimate interest</p>
    <p>To interact with the Experience and record and create Video Content</p>
    <p>
      (a) Identity Data
      <br />
      (b) Contact Data
      <br />
      (c) Technical Data
      <br />
      (d) Usage Data
    </p>
    <p>Performance of a contract with you</p>
    <p>To interact with the Experience to:</p>
    <p>
      (a) Share a personalised URL linking to the Video Content on your Social
      Media
      <br />
      (b) Share a personalised URL linking to the Video Content to other
      individuals
      <br />
      (c) Save and download the Video Content onto your server
    </p>
    <p>
      (a) Identity Data
      <br />
      (b) Contact Data
      <br />
      (c) Technical Data
      <br />
      (d) Usage Data
    </p>
    <p>Performance of a contract with you</p>
    <p>To manage our relationship with you which will include:</p>
    <p>
      (a) Notifying you about changes to our terms or privacy policy
      <br />
      (b) Asking you to leave a review or take a survey
    </p>
    <p>
      (a) Identity Data
      <br />
      (b) Contact Data
      <br />
      (c) Technical Data
      <br />
      (d) Usage Data
    </p>
    <p>
      (a) Performance of a contract with you
      <br />
      (b) Necessary to comply with a legal obligation
      <br />
      (c) Necessary for our legitimate interests (to keep our records updated
      and to study how customers use our products/services, so that we can
      develop the Experience to suit the demands and preferences of those
      interacting with the Experience)
    </p>
    <p>
      To administer and protect our business and the Experience (including
      troubleshooting, data analysis, testing, system maintenance, support,
      reporting and hosting of data)
    </p>
    <p>
      (a) Identity Data
      <br />
      (b) Contact Data
      <br />
      (c) Technical Data
    </p>
    <p>
      (a) Necessary for our legitimate interests (for running our business,
      provision of administration and IT services, network security, to prevent
      fraud and in the context of a business reorganisation or group
      restructuring exercise)
    </p>
    <p>
      To deliver relevant content to you and measure or understand the
      effectiveness of the advertising we serve to you
    </p>
    <p>
      (a) Identity Data
      <br />
      (b) Contact Data
      <br />
      (c) Technical Data
      <br />
      (d) Usage Data
    </p>
    <p>
      Necessary for our legitimate interests (to study how customers use our
      products/services, to develop them, to grow our business and to inform our
      marketing strategy)
    </p>
    <p>
      To use data analytics to improve the Experience, products/services,
      marketing, customer relationships and experiences
    </p>
    <p>
      (a) Technical Data
      <br />
      (b) Usage Data
    </p>
    <p>
      Necessary for our legitimate interests (to define types of customers for
      our products and services, to keep the Experience updated and relevant, to
      develop our business and to inform our marketing strategy)
    </p>
    <p>Marketing and Promotional offers from us</p>
    <p>We will not send you marketing or promotional communications.</p>
    <p>Cookies</p>
    <p>
      Cookies are small pieces of text and data sent to your web browser by a
      website you visit. A cookie file contains such information as how long was
      spent on that particular website, the site preferences and how frequently
      the Experience is visited. The Experience uses Netlify Analytics and does
      not use cookies.
    </p>
    <p>
      Please note that External Third Parties may use cookies, over which we
      have no control. Pentagram accepts no liability in relation to any use of
      cookies by any third-party. You can set your browser to refuse all or some
      browser cookies, or to alert you when websites set or access cookies.
    </p>
    <p>5. Disclosures of your Personal Data</p>
    <p>
      We may have to share your Personal Data with the third parties, including
      but not limited to those parties set out below, for the purposes set out
      in the table in paragraph 4 above.
    </p>
    <p>
      External third parties which include processors in the following
      categories:
    </p>
    <p>Social Media platforms (at your own election)</p>
    <p>Analytics providers</p>
    <p>Our hosting provider</p>
    <p>
      Third parties to whom we may choose to sell, transfer, or merge parts of
      our business or our assets. Alternatively, we may seek to acquire other
      businesses or merge with them. If a change happens to our business, then
      the new owners may use your Personal Data in the same way as set out in
      this privacy policy.
    </p>
    <p>
      We require all third parties to respect the security of your Personal Data
      and to treat it in accordance with the law. We do not allow our
      third-party service providers to use your Personal Data for their own
      purposes and only permit them to process your Personal Data for specified
      purposes and in accordance with our instructions which, for the avoidance
      of doubt, will be in accordance with the purposes for which the data was
      collected. Pentagram is however not liable nor responsible for how the
      Social Media platforms you elect to share your Personal Data with process
      or use the Personal Data derived from the Experience.
    </p>
    <p>6. International transfers</p>
    <p>
      Some of our external third parties are based outside the European Union (
      EU) so their processing of your Personal Data will involve a transfer of
      data outside the EEA.
    </p>
    <p>
      Whenever we transfer your Personal Data out of the EU, we ensure a similar
      degree of protection is afforded to it by ensuring at least one of the
      following safeguards is implemented:
    </p>
    <p>
      Where we use certain service providers, we may use specific contracts
      approved by the European Commission which give Personal Data the same
      protection it has in Europe. For further details, see European Commission:
      Model contracts for the transfer of Personal Data to third countries.
    </p>
    <p>
      Where we use providers based in the US, such as AWS, we may transfer data
      to them if they are part of the Privacy Shield which requires them to
      provide similar protection to Personal Data shared between the Europe and
      the US. For further details, see European Commission: EU-US Privacy
      Shield.
    </p>
    <p>
      Please contact us if you want further information on the specific
      mechanism used by us when transferring your Personal Data out of the EU.
    </p>
    <p>7. Data security</p>
    <p>
      We have put in place appropriate security measures to prevent your
      Personal Data from being accidentally lost, used or accessed in an
      unauthorised way, altered or disclosed. In addition, we limit access to
      your Personal Data to those employees, agents, contractors and other third
      parties who have a business need to know. They will only process your
      Personal Data on our instructions and they are subject to a duty of
      confidentiality. We have put in place procedures to deal with any
      suspected Personal Data breach and will notify you and any applicable
      regulator of a breach where we are legally required to do so.
    </p>
    <p>8. Data retention</p>
    <p>How long will you use my Personal Data for?</p>
    <p>
      We will only retain your Personal Data for as long as necessary to fulfil
      the purposes we collected it for, including for the purposes of satisfying
      any legal, accounting, or reporting requirements. Once these have been
      satisfied, the Personal Data (other than the Video Content itself) will
      either be deleted or amended to the extent that it would be considered
      Anonymous Data.
    </p>
    <p>
      To determine the appropriate retention period for Personal Data, we
      consider the amount, nature, and sensitivity of the Personal Data, the
      potential risk of harm from unauthorised use or disclosure of your
      Personal Data, the purposes for which we process your Personal Data and
      whether we can achieve those purposes through other means, and the
      applicable legal requirements.
    </p>
    <p>
      In some circumstances you can ask us to delete your Personal Data: see
      Erasure Request below for further information. In some circumstances we
      may anonymise your Personal Data (so that it can no longer be associated
      with you) for research or statistical purposes in which case we may use
      this information indefinitely without further notice to you.
    </p>
    <p>9. Your legal rights</p>
    <p>
      Under certain circumstances, you have rights under the Data Protection
      Legislation in relation to your Personal Data.
    </p>
    <p>You have the right to:</p>
    <p>
      Request access to your Personal Data (commonly known as a " Data Subject
      Access Request"). This enables you to receive a copy of the Personal Data
      we hold about you.
    </p>
    <p>
      Request correction of the Personal Data that we hold about you. This
      enables you to have any incomplete or inaccurate data we hold about you
      corrected, though we may need to verify the accuracy of the new data you
      provide to us.
    </p>
    <p>
      Request erasure of your Personal Data (commonly known as an &ldquo;
      Erasure Request&rdquo;). This enables you to ask us to delete or remove
      Personal Data where there is no good reason for us continuing to process
      it. You also have the right to ask us to delete or remove your Personal
      Data where you have successfully exercised your right to object to
      processing (see below), where we may have processed your information
      unlawfully or where we are required to erase your Personal Data to comply
      with the Data Protection Legislation. Note, however, that we may not
      always be able to comply with your request of erasure for specific legal
      reasons which will be notified to you, if applicable, at the time of your
      request.
    </p>
    <p>
      Object to processing of your Personal Data where we are relying on a
      legitimate interest (or those of a third party) and there is something
      about your particular situation which makes you want to object to
      processing on this ground as you feel it impacts on your fundamental
      rights and freedoms. You also have the right to object where we are
      processing your Personal Data for direct marketing purposes. In some
      cases, we may demonstrate that we have compelling legitimate grounds to
      process your information which override your rights and freedoms.
    </p>
    <p>
      Request restriction of processing of your Personal Data. This enables you
      to ask us to suspend the processing of your Personal Data in the following
      scenarios: (a) if you want us to establish the data's accuracy; (b) where
      our use of the data is unlawful but you do not want us to erase it; (c)
      where you need us to hold the data even if we no longer require it as you
      need it to establish, exercise or defend legal claims; or (d) you have
      objected to our use of your data but we need to verify whether we have
      overriding legitimate grounds to use it.
    </p>
    <p>
      Request the transfer of your Personal Data to you or to a third party. We
      will provide to you, or a third party you have chosen, your Personal Data
      in a structured, commonly used, machine-readable format. Note that this
      right only applies to automated information which you initially provided
      consent for us to use or where we used the information to perform a
      contract with you. In addition, this does not provide you with routine
      access to our systems and processes and only the extraction of your
      Personal Data.
    </p>
    <p>
      Withdraw consent at any time where we are relying on consent to process
      your Personal Data. However, this will not affect the lawfulness of any
      processing carried out before you withdraw your consent. If you withdraw
      your consent, we may not be able to provide certain products or services
      to you. We will advise you if this is the case at the time you withdraw
      your consent.
    </p>
    <p>
      If you wish to exercise any of the rights set out above, please contact
      us.
    </p>
    <p>No fee usually required</p>
    <p>
      You will not have to pay a fee to access your Personal Data (or to
      exercise any of the other rights). However, we may charge a reasonable fee
      if your request is clearly unfounded, repetitive or excessive.
      Alternatively, we may refuse to comply with your request in these
      circumstances.
    </p>
    <p>What we may need from you</p>
    <p>
      We may need to request specific information from you to help us confirm
      your identity and ensure your right to access your Personal Data (or to
      exercise any of your other rights). This is a security measure to ensure
      that Personal Data is not disclosed to any person who has no right to
      receive it. We may also contact you to ask you for further information in
      relation to your request to speed up our response.
    </p>
    <p>Time limit to respond</p>
    <p>
      We try to respond to all legitimate requests within one month of the time
      we receive all of the information required to complete your request.
      Occasionally it may take us longer than a month if your request is
      particularly complex or you have made a number of requests. In this case,
      we will notify you and keep you updated.
    </p>
    <p>Questions and contact</p>
    <p>
      If you have any questions about this privacy policy, including any
      requests to exercise your legal rights, please contact us using the
      details set out below.
    </p>
    <p>
      You have the right to make a complaint at any time to the Information
      Commissioner's Office (ICO), the UK supervisory authority for data
      protection issues (www.ico.org.uk). We would, however, appreciate the
      chance to deal with your concerns before you approach the ICO so please
      contact us in the first instance.
    </p>
    <p>Contact details</p>
    <p>Our details are:</p>
    <p>
      Full name of legal entity: Pentagram Design Limited (company number
      01599748)
    </p>
    <p>Postal address: 11 Needham Road, London, W11 2RP.</p>
    <p>Email: london@pentagram.com</p>
    <p>Telephone: +44 (0)20 7229 3477</p>
    <p>
      If you wish to contact us regarding your rights, we reserve the right to
      request copies of your identification or any other information that may be
      reasonably required to verify your identity.
    </p>
  </div>
);
